import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { Router } from '@angular/router';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { Registry } from '@/registry.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PracticeCommunicationModel } from '@/models/practice-communication-model';
import { DialogDetailCommunicationPracticeComponent } from '@pages/practices-management/practices/practice-details/dialogs/dialog-detail-communication/dialog-detail-communication-practice.component';

@Component({
  selector: 'app-button-practice-communication-detail',
  templateUrl: '../button.component.html',
  styleUrls: ['../button.component.scss'],
})
export class ButtonDetailPracticeCommunicationComponent extends ButtonComponent implements OnInit {
  faIcon = faPenToSquare;
  private dialogOpened: MatDialogRef<any>;
  private communicationModel: PracticeCommunicationModel;
  private rowData: any;

  constructor(
    protected router: Router,
    protected toastr: ToastrService,
    private dialog: MatDialog,
  ) {
    super(router, toastr);

    this.showIcon = true;
    this.additionalClass = 'py-0.5 px-2.5';
    this.smallBtn = true;
  }

  ngOnInit() {
    this.communicationModel = <PracticeCommunicationModel>this.rowData;
  }

  /**
   * Open practice communication detail page
   */
  public actionClick(): void {
    this.dialogOpened = this.dialog.open(DialogDetailCommunicationPracticeComponent, {
      data: this.communicationModel,
    });

    Registry.getInstance().set('DialogDetailCommunicationPracticeComponent', this.dialogOpened);
  }
}
